import { TilopayPaymentConfirmation } from '#app/components/billing/tilopay-payment-confirmation.tsx'

export default function TilopayPaymentTestRoute() {
	return (
		<TilopayPaymentConfirmation
			autoSubmit={false}
			callbackData={{}}
			detail="Estamos verificando compra de 100 chats con Tilopay. Esto puede tardar unos segundos."
		/>
	)
}
